import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles/mobile.css'

// Suppress known MUI aria-hidden warning (harmless accessibility warning from MUI modals)
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' && 
    args[0].includes('aria-hidden on an element because its descendant retained focus')
  ) {
    return;
  }
  originalError.apply(console, args);
};

// StrictMode disabled for better development performance
// Re-enable in production if needed for additional checks
createRoot(document.getElementById('root')).render(
  <App />,
) 